<template>
  <div class="wtv-map" ref="map">
    <!-- <div class="whs-map-toggler whs-icon" @click="toggleMap"></div> -->
    <!-- <div class="wtv-map-container" ref="mapContainer"></div> -->
    <l-map
      :zoom="12"
      :center="[latitude, longitude]"
    >

      <l-tile-layer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      ></l-tile-layer>

      <l-marker :lat-lng="[latitude, longitude]" draggable>
        <!-- <l-tooltip>
          lol
        </l-tooltip> -->
      </l-marker>

    </l-map>
  </div>
</template>

<script>
import {
  LMap, LTileLayer, LMarker,
} from '@vue-leaflet/vue-leaflet';
import { defineComponent /*  reactive, onMounted */ } from 'vue';

// const { L } = window;

export default defineComponent({
  name: 'Map',
  props: {
    longitude: Number,
    latitude: Number,
    countrycode: String,
  },
  components: {
    LMap,
    LTileLayer,
    LMarker,
  },
  setup() {
    // const reactiveData = reactive({
    //   api: '',
    //   marker: null,
    //   tiles: null,
    //   map: null,
    // });
    // const includeMap = () => {
    //   const data = reactiveData;
    //   const mapContainer = ref(null);
    //   if (!data.map) data.map = LMap(mapContainer);

    //   data.map.setView([data.latitude, data.longitude], 12);

    //   if (data.countrycode === '47' && data.api !== 'osm') {
    //     if (data.tiles) data.map.removeLayer(data.tiles);
    //     data.tiles = LTileLayer('https://{s}.tile.osm.org/{z}/{x}/{y}.png', {
    //       attribution:
    //         '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    //     });
    //     data.api = 'osm';
    //   }

    //   if (data.countrycode !== '47' && data.api !== 'mapbox') {
    //     if (data.tiles) data.map.removeLayer(data.tiles);
    //     data.tiles = LTileLayer(
    //       'https://api.mapbox.com/styles/v1/mapbox/outdoors-v9/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoidXZhcm92IiwiYSI6ImNqeXU5MzJ3aDBiamczbm1kcW93cno1bjEifQ.aeewME_t3TtRzp9ukojXeg',
    //       { tileSize: 512, zoomOffset: -1 },
    //     );
    //     data.api = 'mapbox';
    //   }

    //   data.tiles.addTo(data.map);
    //   data.marker = L.marker([data.latitude, data.longitude]).addTo(data.map);
    // };
    // onMounted(includeMap);
  },
  // data() {
  //   return reactive({
  //     api: '',
  //     marker: null,
  //     tiles: null,
  //     map: null,
  //   });
  // },
  // props: {
  //   longitude: Number,
  //   latitude: Number,
  //   countrycode: String,
  // },
  // methods: {
  //   includeMap() {
  //     if (!this.map) this.map = L.map(this.$refs.mapContainer);

  //     this.map.setView([this.latitude, this.longitude], 12);

  //     if (this.countrycode === '47' && this.api !== 'osm') {
  //       if (this.tiles) this.map.removeLayer(this.tiles);
  //       this.tiles = L.tileLayer('https://{s}.tile.osm.org/{z}/{x}/{y}.png', {
  //         attribution:
  //           '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
  //       });
  //       this.api = 'osm';
  //     }

  //     if (this.countrycode !== '47' && this.api !== 'mapbox') {
  //       if (this.tiles) this.map.removeLayer(this.tiles);
  //       this.tiles = L.tileLayer(
  //         'https://api.mapbox.com/styles/v1/mapbox/outdoors-v9/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoidXZhcm92IiwiYSI6ImNqeXU5MzJ3aDBiamczbm1kcW93cno1bjEifQ.aeewME_t3TtRzp9ukojXeg',
  //         { tileSize: 512, zoomOffset: -1 },
  //       );
  //       this.api = 'mapbox';
  //     }

  //     this.tiles.addTo(this.map);
  //     this.marker = L.marker([this.latitude, this.longitude]).addTo(this.map);
  //   },
  // },
  // mounted() {
  //   this.includeMap();
  // },
});
</script>

<style scoped>
.wtv-map {
  width: 100%;
  height: 400px;
  z-index: 0;
  position: relative;
}
.wtv-result-hotel-map .wtv-map {
  height: 300px;
}
.wtv-map-container {
  width: 100%;
  height: 100%;
}
</style>
